import { useCallback, useEffect } from 'react'
import { useBoolean } from './useBoolean'
import { useCounter } from './useCounter'
import { useInterval } from './useInterval'

/**
 *
 * @param seconds the countdown's number, generally time seconds
 * @param interval the countdown's interval in milliseconds
 * @param isIncrement determine the countdown is increment, otherwise is decrement
 * @param lowerBoundaryLimit the countdown's minimum thershold value to stop if isIncrement is false
 * @param upperBoundaryLimit the countdown's maximum thershold value to stop if isIncrement is true
 * @returns An array with two parameters.
 *          @param count is the current value of the counter
 *          @param object with the following properties: start, stop, running, and reset.
 */
export function useCountdown(options = {}) {
  const {
    seconds = 30,
    interval = 1000,
    lowerBoundaryLimit = -Infinity,
    upperBoundaryLimit = Infinity,
    isIncrement = false
  } = options

  const [count, counterActions] = useCounter(seconds)
  const [running, intervalActions] = useBoolean(false)

  const reset = useCallback(() => {
    intervalActions.setFalse()
    counterActions.reset()
  }, [intervalActions, counterActions])

  useInterval(
    isIncrement ? counterActions.increment : counterActions.decrement,
    running ? interval : null
  )

  useEffect(() => {
    if (!running) return
    if (
      (isIncrement && count >= upperBoundaryLimit) ||
      (!isIncrement && count <= lowerBoundaryLimit)
    ) {
      reset()
    }
  }, [count, running])

  return [
    count,
    {
      start: intervalActions.setTrue,
      stop: intervalActions.setFalse,
      running,
      reset
    }
  ]
}
